module.exports = __webpack_public_path__ + "static/media/redfbBg3.2aad6398.png";